import { FC, useState } from 'react';
import { useTemplateData } from './useTemplateData';
import { SensorDataObject } from '../../types/types';
import { DataObject } from '../../types/api';
import AirQuality from './AirQuality';
import { Grid } from '@mui/material';
import SensorCard from './SensorCard';
import * as R from 'ramda';
import { IoTSystem, StructuralElement } from '../../types/api';
import Loading from 'components/Loading';

// TEMPORARY CONSTANTS TO INDICATE MEASUREMENTS
export const TEMPERATURE = 'Temperature_MR';
export const HUMIDITY = 'Humidity_MR';
export const CO2 = 'CO2_MR';
export const PARTICLES = 'PM25_MR';
export const VOCS = 'SGPTVOC_MR';

function isNotNull(value: any) {
  return R.isNil(value) ? [] : value;
}

const RealTimeIEQ: FC = () => {
  const { data, isLoading } = useTemplateData();
  const [selectedSensors, setSelectedSensors] = useState<SensorDataObject[][]>(
    []
  );

  if (isLoading) {
    return <Loading isCentered={true} />;
  }

  if (!data) {
    return <div />;
  }

  const values: SensorDataObject[] = R.flatten(
    isNotNull(data.systems).map((s: IoTSystem) =>
      isNotNull(s.structure).map((st: StructuralElement) =>
        isNotNull(st.subElements).map((sub: StructuralElement) =>
          sub.subElements
            ?.filter((subsub) => subsub.data !== undefined)
            .map((subsub) => subsub.data as SensorDataObject[])
        )
      )
    )
  );

  const locations: StructuralElement[] = R.flatten(
    isNotNull(data.systems).map((s: IoTSystem) =>
      isNotNull(s.structure).map((st: StructuralElement) =>
        isNotNull(st.subElements).map((sub: StructuralElement) =>
          sub.subElements
            ?.filter((subsub) => subsub.data !== undefined)
            .map((subsub) => subsub as StructuralElement[])
        )
      )
    )
  );



  // Split into arrays of 5.
  // Example: [[Thermal, AirQuality, ViralInfection], [Thermal, AirQuality, ViralInfection], [Thermal, AirQuality, ViralInfection]]
  const sensorChuncks =
    values.length > 0
      ? R.splitEvery(5, R.flatten(values)).filter((x) => x.length !== 0)
      : [];

  if (sensorChuncks.length === 1 || selectedSensors?.length === 1) {
    // Single sensor
    const sensor =
      selectedSensors?.length === 1 ? selectedSensors[0] : sensorChuncks[0];
    return (
      <AirQuality
        key={sensor[0].variableName}
        data={sensor}
        goBack={() => setSelectedSensors([])}
        isBackButtonVisible={sensorChuncks.length > 1}
      />
    );
  } else if (sensorChuncks.length > 1) {
    // Multiple sensors
    return (
      <Grid container spacing={2} className="Sensors">
        {sensorChuncks.map((sensor,i) => (
          <Grid key={sensor[0]?.variableName} item xs={12} sm={6} lg={4}>
            <SensorCard
              location={locations[i]}
              sensorData={sensor}
              openSensorDetails={() => setSelectedSensors([sensor])}
            />
          </Grid>
        ))}
      </Grid>
    );
  } else {
    return <div />;
  }
};

export default RealTimeIEQ;
